module.exports = __webpack_public_path__ + "img/KSC09597.1f983288.jpg";